import fetchData from 'src/utils/fetchData';

export const postAuthorizationStartAPI = async (data: any) => {
  return fetchData('/ui/front-api/public/session/authorization/start', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: data,
  });
};

export const getAuthorizationStateAPI = async () => {
  return fetchData('/ui/front-api/public/session/authorization/state');
};

export const getAuthorizationInfoAPI = async () => {
  return fetchData('/ui/front-api/public/session/authorization/info');
};

export const postTwoFactorPhoneAuthorizationStartAPI = async (data: any) => {
  return fetchData('/ui/front-api/public/session/authorization/two-factor/phone/start', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
};

export const getTwoFactorPhoneAuthorizationStateAPI = async () => {
  return fetchData('/ui/front-api/public/session/authorization/two-factor/phone/state');
};

export const postTwoFactorPhoneAuthorizationConfirmAPI = async (data: any) => {
  return fetchData('/ui/front-api/public/session/authorization/two-factor/phone/confirm', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: data,
  });
};

export const postTwoFactorEmailAuthorizationStartAPI = async () => {
  return fetchData('/ui/front-api/public/session/authorization/two-factor/email/start', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getTwoFactorEmailAuthorizationStateAPI = async () => {
  return fetchData('/ui/front-api/public/session/authorization/two-factor/email/state');
};

export const postTwoFactorEmailAuthorizationConfirmAPI = async (data: any) => {
  return fetchData('/ui/front-api/public/session/authorization/two-factor/email/confirm', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: data,
  });
};

export const postConfirmByPasswordAPI = async (data: any) => {
  return fetchData('/ui/front-api/public/session/authorization/confirm-by-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
};

// бэкенд возвращает 302 статус при успешном разлогине (редирект)
// чтобы скрипт фронта не потерял управление запросом, необходимо передавать параметр redirect: 'manual'
export const getLogoutAPI = async () => {
  return fetchData('/ui/logout', {
    redirect: 'manual',
  });
};
